import axios from 'axios';
import consts from '../consts';
import { initialize } from 'redux-form';
import { setErroAPI, setSuccess } from '../common/toast/toast';

const API = `${consts.API_URL}/manutencao`;

export const MANUTENCAO_MODO_TELA = 'MANUTENCAO_MODO_TELA';
export const MANUTENCAO_AGUARDANDO = 'MANUTENCAO_AGUARDANDO';
export const MANUTENCAO_LISTADO = 'MANUTENCAO_LISTADO';
export const MANUTENCAO_OPCOES = 'MANUTENCAO_OPCOES';

const numero = valor => {
    if (valor === null || valor === undefined || valor === '') return null;
    const texto = valor.toString().trim();
    const resultado = Number(
        texto.includes(',')
            ? texto.replace(/\./g, '').replace(',', '.')
            : texto
    );
    return Number.isFinite(resultado) ? resultado : null;
};

const dataHoraUtc = valor => {
    if (!valor || /Z$/i.test(valor) || /[+-]\d{2}:\d{2}$/.test(valor)) {
        return valor;
    }
    const data = new Date(valor);
    return Number.isNaN(data.getTime()) ? valor : data.toISOString();
};

const normalizar = registro => ({
    ...registro,
    id_veiculo: Number(registro.id_veiculo) || null,
    datahora_manutencao: dataHoraUtc(registro.datahora_manutencao),
    odometro: numero(registro.odometro),
    horimetro: numero(registro.horimetro),
    descricao: (registro.descricao || '').trim(),
    itens: (registro.itens || []).map(item => ({
        id: Number(item.id) || null,
        descricao: (item.descricao || '').trim(),
        valor: numero(item.valor)
    }))
});

export const setModoTela = (modo, registro = {}) => ({
    type: MANUTENCAO_MODO_TELA,
    payload: { modo, registro }
});

export const setAguardando = aguardando => ({
    type: MANUTENCAO_AGUARDANDO,
    payload: aguardando
});

export function initForm(registro = {}) {
    let datahora = registro.datahora_manutencao;
    const data = datahora ? new Date(datahora) : new Date();
    if (!Number.isNaN(data.getTime())) {
        data.setMinutes(data.getMinutes() - data.getTimezoneOffset());
        datahora = data.toISOString().substring(0, 16);
    }

    return initialize('manutencaoForm', {
        descricao: '',
        ...registro,
        itens: registro.itens && registro.itens.length
            ? registro.itens
            : [{ descricao: '', valor: 0 }],
        datahora_manutencao: datahora
    });
}

export function getLista() {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));
            const resp = await axios.get(API);
            dispatch({ type: MANUTENCAO_LISTADO, payload: resp.data });
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function getOpcoes() {
    return async dispatch => {
        try {
            const resp = await axios.get(`${API}/opcoes`);
            dispatch({ type: MANUTENCAO_OPCOES, payload: resp.data });
        } catch (erro) {
            setErroAPI(erro);
        }
    };
}

export function salvar(registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));
            const dados = normalizar(registro);
            if (dados.id) await axios.put(API, dados);
            else await axios.post(API, dados);
            setSuccess(dados.id ? 'Manutenção atualizada.' : 'Manutenção incluída.');
            dispatch(getLista());
            dispatch(setModoTela('lista'));
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function excluir(registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));
            await axios.delete(API, { params: { id: registro.id } });
            setSuccess('Manutenção excluída.');
            dispatch(getLista());
            dispatch(setModoTela('lista'));
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}
